import { UseQueryResult, useQuery } from "react-query";
import { TemplatesHistoryResponse, useQueryApiError } from "../types";
import { useUser } from "./useUser";
import { getTemplatesHistoryService } from "../services/templateHistoryService";
import { Dispatch, SetStateAction, useState } from "react";

type useQueryConsentHistoryHookType = {
  consentHistoryUseQuery: UseQueryResult<TemplatesHistoryResponse, useQueryApiError>;
  setFetched: Dispatch<SetStateAction<boolean>>;
};

type Params = {
  country?: string;
  business?: string;
  purposeName?: string;
  page?: number;
  limit?: number;
};

export const useConsentHistory = ({
  country,
  business,
  purposeName,
  page,
  limit
}: Params): useQueryConsentHistoryHookType => {
  const [fetched, setFetched] = useState(false);
  const { user } = useUser();

  const consentHistoryUseQuery = useQuery<TemplatesHistoryResponse, useQueryApiError>(
    ["getConsentHistory", country, business, purposeName],
    async () => {
      const response = await getTemplatesHistoryService({
        country,
        business,
        purposeName,
        page,
        limit,
        token: user.token
      });

      return response;
    },
    { cacheTime: 0, retry: 1, enabled: fetched }
  );

  return {
    consentHistoryUseQuery,
    setFetched
  };
};
